module.exports = __webpack_public_path__ + "static/button-0f0dc0fa249b9f4a73ef4144edf12d44.png";